/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { LegalTechSkill } from '../enums/legal-tech-skill';
import { LegalTechSkillCategory } from '../enums/legal-tech-skill-category';
import { LegalTechnicalSkillProficiency } from '../enums/legal-technical-skill-proficiency';
import { CandidateEntity } from './candidate-entity';
export class CandidateLegalTechnicalSkillEntity extends Entity {
  candidate: CandidateEntity | null = null;
  candidateId: string = '';
  createdAt: string | null = null;
  id: string = '';
  legalTechCategory: LegalTechSkillCategory | null = null;
  legalTechSkill: LegalTechSkill | null = null;
  proficiency: LegalTechnicalSkillProficiency | null = null;
  updatedAt: string | null = null;
  static override key = 'CandidateLegalTechnicalSkill';
  static override get schema() {
    return {
      candidate: CandidateEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateLegalTechnicalSkill' in input
    ) {
      const { CandidateLegalTechnicalSkill: wrapped, ...rest } = input as {
        CandidateLegalTechnicalSkill: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}